import { Component, EventEmitter, ViewEncapsulation, Output, OnDestroy, OnInit, Host, HostBinding } from '@angular/core';
import { Subscription } from 'rxjs';
import { GraduationPlanService } from './graduation-plan.service';
import { GradPlanTypeModel, GraduationPlanModel } from './graduation-plan.model';
import { GPFilterParam } from './gp-filter-param';
import { OverrideCreditcodeComponent } from './override-creditcode/override-creditcode.component';
import { StudentService } from '../../shared-components/student/student.service';
import { User } from '../../shared-components/user/user.model';
import { UserService } from '../../shared-components/user/user.service';
import { TylerMatTableDataSource } from '../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../shared-components/angular-material/mat-animations';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-graduation-plan',
    templateUrl: './graduation-plan.component.html',
    styleUrls: ['./graduation-plan.component.css'],
    animations: [detailExpand],
    encapsulation: ViewEncapsulation.None
})
export class GraduationPlanComponent implements OnInit, OnDestroy {
    @HostBinding('class.sis-app-root') sisAppRoot: Host = true;
    @Output() clearFilterEvent = new EventEmitter<any>();
    @Output() showFilterEvent = new EventEmitter<any>();

    // -----------Grid functionality---------------------------------
    graduationplanTypes: GradPlanTypeModel[] = [];
    primayGradPlan = new GraduationPlanModel();
    subscriptions: Subscription[] = [];
    showFilter = false;
    isFiltered = false;
    gpFilterParam = new GPFilterParam();
    currentUser: User;

    toggleAllRows: EventEmitter<boolean> = new EventEmitter<boolean>();
    CreditCodeOverrideDialogRef: MatDialogRef<OverrideCreditcodeComponent>;

    // Table Properties
    tableData = new TylerMatTableDataSource();
    universalColumns = [
        'required',
        'attempted',
        'earned',
        'current',
        'requested',
        'over',
        'need',
        'status'
    ];
    headerTableColumns = [
        'more',
        'name'
    ].concat(this.universalColumns);
    gradPlanTableColumns = ['more', 'graduationPlan'].concat(this.universalColumns);
    subjectAreaColumns = ['more', 'subjectArea'].concat(this.universalColumns);
    creditCodeColumns = ['creditCodeTableMore', 'creditCode'].concat(this.universalColumns);
    courseColumns = ['course'].concat(this.universalColumns);
    previousDisplay = '';
    gradPlans: GraduationPlanModel[] = [];

    constructor(
        private graduationplanService: GraduationPlanService,
        private studentService: StudentService,
        private userService: UserService,
        private dialog: MatDialog
    ) {

    }

    ngOnInit() {
        this.graduationplanService.gpFilterParam = this.gpFilterParam;
        this.subscriptions.push(
            this.studentService.selectedStudentStream$.subscribe(
                studentId => {
                    this.graduationplanService.getgraduationplanData();
                }
            )
        );
        this.currentUser = this.userService.currentUser;
        this.graduationplanService.graduationPlanFetch_Complete.subscribe(arg => {
            this.graduationplanTypes = this.graduationplanService.graduationplanTypes;
            this.gradPlans = [];
            this.graduationplanTypes.forEach(planType => {
                planType.GraduationPlans.forEach(gradPlan => {
                    this.gradPlans.push(gradPlan);
                });
            });
            this.primayGradPlan = this.graduationplanService.getPrimaryGraduationPlan();
            this.filterChanged('init');
        });

        // footer expand/collapse button events.
        this.subscriptions.push(
            this.toggleAllRows.subscribe(toggle => {

                // Helper function
                const expandOrCollapse = (expand: boolean, object: any = this) => {
                    let tableData = object.tableData;
                    if (tableData == null && object.getTableData) {
                        tableData = object.getTableData(this.gpFilterParam);
                    }
                    if (tableData) {
                        tableData.expandAll(expand);
                        for (let i = 0; i < tableData.data.length; i++) {
                            expandOrCollapse(expand, tableData.data[i]);
                        }
                    }
                };

                // Expanding or collapsing
                expandOrCollapse(toggle);

                // Toggling status ???
                this.onToggleStatusAll(toggle);
            })
        );
    }

    filterChanged(type: string) {
        Object.assign(this.graduationplanService.gpFilterParam, this.gpFilterParam);
        // this.graduationplanService.gpFilterParam = this.gpFilterParam; // We can't do this to prevent infinite loops
        this.onToggleStatusAll(true);

        // Graduation Plan Filtering
        // NOTE: other filtering handled in the model's "getTableData" function
        this.tableData.data = this.gradPlans.filter(gradPlan => {
            if (!gradPlan.IsPrimary) {
                return false;
            } else if (!this.gpFilterParam.GradPlanStatus || this.gpFilterParam.GradPlanStatus.includes('all')) {
                return true;
            } else {
                return this.gpFilterParam.GradPlanStatus.includes(gradPlan.Status);
            }
        });

        // Expanding based on default display
        if (this.previousDisplay != this.gpFilterParam.DefaultDisplay || type == 'init') {
            this.tableData.expandAll(this.gpFilterParam.DefaultDisplay.includes('SA'));
            this.tableData.data.forEach(subjectArea => {
                subjectArea.getTableData(this.gpFilterParam).expandAll(this.gpFilterParam.DefaultDisplay.includes('CC'));
                subjectArea.getTableData(this.gpFilterParam).data.forEach(creditCode => {
                    creditCode.getTableData(this.gpFilterParam).expandAll(this.gpFilterParam.DefaultDisplay.includes('CR'));
                });
            });
            this.previousDisplay = this.gpFilterParam.DefaultDisplay;
        }

        // Setting filtered variable
        this.isFiltered = this.gpFilterParam.isFilterApplied();
    }

    refetchData() {
        this.graduationplanService.getgraduationplanData();
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
        this.graduationplanService.graduationplanTypes = [];
    }

    onToggleStatusAll(toggle: boolean) {
        this.graduationplanService.toggleStatusAll(toggle);
    }

    showFilterClick() {
        this.showFilter = !this.showFilter;
    }

    creditCodeOverrideClick(gpCourseModel) {
        this.CreditCodeOverrideDialogRef = this.dialog.open(OverrideCreditcodeComponent, { panelClass: 'tyl-mat-dialog', disableClose: true });
        this.CreditCodeOverrideDialogRef.componentInstance.gpCourseModel_selected = gpCourseModel;
        this.CreditCodeOverrideDialogRef.componentInstance.creditcode_Overriden.subscribe((event) => {
        });

        this.CreditCodeOverrideDialogRef.afterClosed().subscribe(result => {
        });
    }
}